import Image from 'next/image';
import { getReadableImageUrl } from '@/lib/directus'
import { sanitizeHTML } from '@/lib/utils'

interface HomeWelcomeProps {
	heading?: {
		title?: string
	}
	subheading?: {
		title?: string
	}
	text?: {
		text?: string
	}
	background?: {
		alt: string
		image_file: {
			image: {
				id: string
				filename_download: string
			}
		}
	}
}

export const fields = [
	'heading.title',
	'subheading.title', 
	'text.text',
	'background.alt',
	'background.image_file.image.id',
	'background.image_file.image.filename_download',
] as const

export default function HomeWelcome({ data }: { data: HomeWelcomeProps }) {
  return (
		<section
			id='home-welcome'
			className='HomeWelcome relative bg-sand-light overflow-hidden md:py-28'
		>
			{/* Background Image Container */}
			<div className='absolute inset-0 w-full h-full max-md:relative max-md:h-[380px]'>
				<Image
					src={getReadableImageUrl(
						data?.background?.image_file?.image?.id || '',
						data?.background?.image_file?.image?.filename_download || ''
					)}
					alt={data?.background?.alt || ''}
					fill
					priority
					className='object-cover max-md:object-center'
					quality={90}
				/>
			</div>

			{/* Content Container */}
			<div className='container relative h-full max-md:px-0'>
				<div className='flex h-full items-center justify-end'>
					{/* White Card with rounded border */}
					<div className='w-full max-w-[52.313rem] md:rounded-[0.5rem] max-md:rounded-tr-[50px] max-md:rounded-br-lg bg-white p-12 max-md:px-5 max-md:pt-[2.063rem] max-md:pb-[1.875rem] md:mt-0 mt-[-5rem] relative z-10'>
						
						{data?.subheading?.title && (
							<div className='inline-block rounded-sm bg-sand/20 px-2.5 py-2'>
								<span className='font-brandon text-xl uppercase tracking-wide'>
									{data.subheading.title}
								</span>
							</div>
						)}

						{/* Content */}
						<div className='mt-6 grid gap-8'>
							<h2>
								{data?.heading?.title || ''}
							</h2>

							<div
								className='grid gap-8'
								dangerouslySetInnerHTML={sanitizeHTML(data?.text?.text || '')}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	)
}